import reporter from '@/lib/reporter';
import router from '@/router';
import { Dialog } from 'vant';
import store from '@/store';
import wechat from '@/wechat';
import { isDev, isWeChat, isMiniProgram, wechatAppid, appConfig, userClient } from '@/global';
import services from '@/service';
import dayjs from 'dayjs';
import { clearCache } from '@/enum/enum';

export const phoneReg = /^1[3456789]\d{9}$/;

export const businessReg = /^[a-zA-Z0-9]{10,20}$/;

export function validatePhoneNumber(phone) {
  return phoneReg.test(phone);
}

export function isValidIdCard(idCard) {
    // 基本格式校验：18位，最后一位可以是X
    const reg = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
    if (!reg.test(idCard)) {
        return false;
    }

    // 提取出生日期并验证
    const year = parseInt(idCard.substr(6, 4), 10);
    const month = parseInt(idCard.substr(10, 2), 10);
    const day = parseInt(idCard.substr(12, 2), 10);
    
    const date = new Date(year, month - 1, day);
    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return false;
    }

    // 校验码验证
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    
    let sum = 0;
    for (let i = 0; i < 17; i++) {
        sum += parseInt(idCard[i], 10) * factor[i];
    }
    
    const lastChar = idCard[17].toUpperCase();
    if (parity[sum % 11] !== lastChar) {
        return false;
    }

    return true;
}

export function blobToUint8Array(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('loadend', e => {
      try {
        const result = e.target.result;
        if (!result) {
          throw new Error('pdf解析失败');
        }
        resolve(result);
      } catch (err) {
        reject(err.message);
      }
    });
    reader.readAsArrayBuffer(blob);
  });
}

export function formatBlobToEext(blob) {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener('loadend', e => {
      try {
        const result = e.target.result;
        if (!result) {
          throw new Error('解析失败');
        }
        resolve(JSON.parse(result));
      } catch (err) {
        resolve();
      }
    });
    reader.readAsText(blob);
  });
}

export function arrayToTree(sNodes, options = {}) {
  let i, l;
  const key = options.key || 'id';
  const parentKey = options.parentKey || 'parentId';
  const childKey = options.childKey || 'children';
  if (!key || key == '' || !sNodes) return [];

  const arr = JSON.parse(JSON.stringify(sNodes));

  if (arr instanceof Array) {
    const r = [];
    const tmpMap = [];
    for (i = 0, l = arr.length; i < l; i++) {
      tmpMap[arr[i][key]] = arr[i];
    }
    for (i = 0, l = arr.length; i < l; i++) {
      if (tmpMap[arr[i][parentKey]] && arr[i][key] != arr[i][parentKey]) {
        if (!tmpMap[arr[i][parentKey]][childKey]) tmpMap[arr[i][parentKey]][childKey] = [];

        tmpMap[arr[i][parentKey]][childKey].push(arr[i]);
      } else {
        r.push(arr[i]);
      }
    }
    return r;
  } else {
    return [arr];
  }
}

export function treeToArray(tree, options = {}) {
  const { level = 0, fullParentId = '' } = options;
  const arr = [];

  tree.forEach(item => {
    arr.push({ ...item, level, fullParentId });
    if ((item.children || []).length > 0) {
      const childFullParentId = fullParentId ? [...fullParentId.split('/'), item.id].join('/') : item.id;
      arr.push(...treeToArray(item.children, { level: level + 1, fullParentId: childFullParentId }));
    }
  });

  return arr;
}

export function formatMoney(value) {
  var param = {};
  var k = 10000,
    sizes = ['', '万', '亿', '万亿'],
    i;
  if (value < k) {
    param.value = value;
    param.unit = '';
  } else {
    i = Math.floor(Math.log(value) / Math.log(k));

    param.value = (value / Math.pow(k, i)).toFixed(2);
    param.unit = sizes[i];
  }
  return param;
}

export function getFilterKeywords({ searchKeywords = [], filterArr = [] }) {
  const words = [...searchKeywords];

  const textSearchItem = filterArr.find(item => item.key === 'textSearch');
  if (textSearchItem) {
    (textSearchItem.value || []).forEach(item => {
      const text = item.value.trim();
      if (text) {
        words.push(text);
      }
    });
  }

  return words;
}

export function formatKeywordByRegexp(title, words = [], replaceVal = '') {
  if (!title || words.length < 1) {
    return title;
  }
  const originTitle = title;

  try {
    title = title.replace(/<\/?[a-zA-Z]+(\s+[a-zA-Z]+=".*")*>/g, '');
    title = title.replace(
      new RegExp('(' + words.join('|') + ')', 'g'),
      replaceVal || '<span style="color: #f86359">$1</span>'
    );
  } catch (err) {
    title = '';
    reporter.log({
      message: `高亮转换失败，title：${originTitle}，搜索词：${JSON.stringify(words)}`
    });
  }

  return title || originTitle;
}

export function getUserType() {
  return window.location.pathname.split('/')[1].split('-')[0];
}

export function getCurToken() {
  return localStorage.getItem(`webview_token_${getUserType()}`);
}

export function inviteUrl(routerName, id) {
  return `${window.location.origin}/${camelToKebab(routerName)}?id=${id}`;
}

// export function setPageTypeToken() {
//   getUserType();
// }

export function signOut() {
  Dialog.confirm({
    title: '提示',
    message: '请确认是否退出登录？'
  }).then(async () => {
    await services.common.logout();
    resetToLogin();
  });
}

export function resetToLogin() {
  store.dispatch('set_token', '');
  store.dispatch('set_openId', '');
  clearCache();
  wxToLogin('reLaunch');
}

// 获取定位时需要重新注册下，否则会失败
export function getLocation() {
  return new Promise(resolve => {
    wechat.refreshSdk(() => {
      console.log('----getLocation----');
      wechat.$wx.getLocation({
        type: 'gcj02',
        success: function(res) {
          resolve(res);
        },
        fail: function() {
          resolve({ latitude: '', longitude: '' });
        }
      });
    });
  });
}

export function openLocation(options) {
  wechat.$wx.openLocation({
    ...options,
    scale: 14
  });
}

export function sharePage({ title, desc, link, partnerId }) {
  if (isMiniProgram) {
    wechat.$wx.miniProgram.navigateTo({ url: `/pages/sharePage/index?partnerId=${partnerId}` });
  } else {
    return new Promise(async resolve => {
      await wechat.$wx.updateAppMessageShareData({ title, desc, link, imgUrl: 'https://img01.yzcdn.cn/vant/logo.png' });
      await wechat.$wx.updateTimelineShareData({ title, desc, link, imgUrl: 'https://img01.yzcdn.cn/vant/logo.png' });
      resolve();
    });
  }
}

export function extractAfterFirstComma(str) {
  const index = str.indexOf(',');
  if (index !== -1) {
    return str.substring(index + 1);
  }
  return str; // 如果没有逗号，则返回原始字符串
}

export function scanQRCode() {
  return new Promise((resolve, reject) => {
    wechat.$wx.scanQRCode({
      needResult: 1,
      success: res => {
        resolve(extractAfterFirstComma(res.resultStr));
      },
      error: function(res) {
        reject(res);
      }
    });
  });
}

export function camelToKebab(camelCase) {
  return camelCase.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function wxAuthTo({ routerName, query }) {
  const openId = store.getters.openId;
  const queryState = window.btoa(JSON.stringify(query));
  if (!isMiniProgram && isWeChat && !isDev && !openId) {
    const redirectUri = `${process.env.VUE_APP_REDIRECT_URI}/${camelToKebab(routerName)}`;
    const href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatAppid}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_type=code&scope=snsapi_base&state=${queryState}&connect_redirect=1#wechat_redirect`;
    window.location.href = href;
  } else {
    router.push({
      name: routerName,
      query: {
        state: queryState
      }
    });
  }
}

export function mallPrescriptionInit(products, mallOrderId, routerType = 'replace') {
  const arr = products
    .filter(i => i.medicineType === 'RX')
    .map(i => ({
      goodsId: i.goodsId,
      number: i.number
    }));
  const queryState = window.btoa(
    JSON.stringify({
      products: arr,
      mallOrderId: mallOrderId
    })
  );

  router[routerType]({
    name: 'mallPrescription',
    query: {
      state: queryState
    }
  });
}

export function mallPrescriptionState(products, mallOrderId) {
  const arr = products
    .filter(i => i.medicineType === 'RX')
    .map(i => ({
      goodsId: i.goodsId,
      number: i.number
    }));
  const queryState = window.btoa(
    JSON.stringify({
      products: arr,
      mallOrderId: mallOrderId
    })
  );

  return queryState;
}

export function hideMiddleChars(str) {
  if (!str || str.length <= 7) {
    return str;
  }

  const firstPart = str.substring(0, 3);
  const lastPart = str.substring(str.length - 4);
  const hiddenLength = str.length - 7;
  const stars = '*'.repeat(hiddenLength);

  return firstPart + stars + lastPart;
}

export async function checkLogin() {
  return new Promise(async resolve => {
    const token = getCurToken();
    if (!token) {
      wxToLogin();
    } else {
      resolve();
    }
  });
}

export function checkTokenTo(cb) {
  const token = getCurToken();
  if (!token && isMiniProgram) {
    wxToLogin();
  } else {
    cb();
  }
}

export function routerPush(options) {
  checkTokenTo(() => {
    router.push({ ...options });
  });
}

export function notRequest() {
  if (!getCurToken() && isMiniProgram) {
    return true;
  }
  return false;
}

// reLaunch/navigateTo
export function wxToLogin(type = 'navigateTo') {
  if (isMiniProgram) {
    wechat.$wx.miniProgram[type]({ url: '/pages/login/index' });
  } else {
    let userType = getUserType();
    if (userType === 'mall') {
      userType = 'patient';
    }
    router.replace({
      path: `/${userType}-login`
    });
  }
}

export async function sleep(ms = 500) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
}

// 日期格式处理
export function getRangeByDate(date, options = {}) {
  const { beginKey = 'beginTime', endKey = 'endTime' } = options;
  const isArr = Array.isArray(date);
  if (!date || (isArr && date.length !== 2)) {
    return {};
  }

  let startDate = '';
  let endDate = '';

  if (isArr) {
    startDate = dayjs(date[0]).format('YYYY-MM-DD');
    endDate = dayjs(date[1]).format('YYYY-MM-DD');
  } else {
    startDate = dayjs(date).format('YYYY-MM-DD');
    endDate = startDate;
  }

  return { [beginKey]: startDate, [endKey]: endDate };
}

export function getCurrentConfig() {
  const type = getUserType();
  if (userClient.includes(type)) {
    return appConfig[type];
  } else {
    return {};
  }
}

export function checkStock(item) {
  return new Promise((resolve, reject) => {
    if (item.stock === 0) {
      Dialog.confirm({
        title: '暂无库存',
        message: '',
        showCancelButton: false
      }).then(() => {
        reject();
      });
    } else {
      resolve();
    }
  });
}

export function onlineCheck() {
  return new Promise((resolve, reject) => {
    const notOnline = false;
    if (notOnline) {
      Dialog.confirm({
        title: '系统维护中',
        message: '',
        showCancelButton: false
      }).then(() => {
        reject();
      });
    } else {
      resolve();
    }
  });
}
